import React from 'react';
import PropTypes from 'prop-types';
import { CircleMarker, GeoJSON, Tooltip } from 'react-leaflet';
import { coverageName, coverageRatioLabel, COVERAGE_COLOR } from '../../../services/TerritoryCoverage';
import './CoverageLayer.css';

export function CoverageLayer({ features, snapshot, selectedId, onSelect }) {
  return features.map((feature) => {
    const p = feature.properties;
    const { geometry, anchor } = feature.displayArea || {};
    const selected = selectedId === p.id;
    const color = COVERAGE_COLOR;
    const name = coverageName(feature);
    const ratio = coverageRatioLabel(feature);
    return (
      <React.Fragment key={`${snapshot}:${p.id}`}>
      {geometry && <GeoJSON
        data={{ ...feature, geometry }}
        style={{
          color, fillColor: color,
          fillOpacity: 0.18, opacity: 0.9, weight: selected ? 4 : 2,
        }}
        onEachFeature={(item, layer) => {
          layer.on('click', () => onSelect(item.properties.id));
        }}
      >
        <Tooltip sticky>
          <span>
            <strong>{coverageName(feature)}</strong>
            <br />{ratio}
            <br />Orders: {p.dispatchable_order_count}
            <br />Mapped drivers: {p.active_driver_count}
          </span>
        </Tooltip>
      </GeoJSON>}
      {anchor && <CircleMarker
        center={[anchor[1], anchor[0]]}
        radius={0}
        opacity={0}
        fillOpacity={0}
      >
        <Tooltip permanent interactive direction="center" className="coverage-territory-label">
          <button
            type="button"
            className="coverage-territory-label__button"
            style={{ '--coverage-color': color }}
            aria-pressed={selected}
            aria-label={`${name} · ${ratio}`}
            title={name}
            onClick={(event) => {
              event.stopPropagation();
              onSelect(p.id);
            }}
          >
            <span className="coverage-territory-label__name">{name}</span>
            <span className="coverage-territory-label__ratio">{ratio}</span>
            <span className="coverage-territory-label__ratio">Orders: {p.dispatchable_order_count} · Drivers: {p.active_driver_count}</span>
          </button>
        </Tooltip>
      </CircleMarker>}
      </React.Fragment>
    );
  });
}

CoverageLayer.propTypes = {
  features: PropTypes.array.isRequired,
  snapshot: PropTypes.string.isRequired,
  selectedId: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};
